import { useLoadedDocumentHandle } from './useLoadedDocumentHandle';

/**
 * Subscribes to the {@link ContentEditorService} and returns the id of the
 * currently loaded content. Returns undefined while no document is loaded.
 *
 * Use this instead of `useParams` when a component (e.g. the action panel)
 * may render outside the route that provides the `:contentId` param.
 */
export function useLoadedContentId(): string | undefined {
  return useLoadedDocumentHandle()?.contentId;
}
